/* eslint-disable */
import { categoryDetailsFragment } from "@saleor/fragments/categories";
import { collectionDetailsFragment } from "@saleor/fragments/collections";
import {
  bulkProductErrorFragment,
  bulkStockErrorFragment,
  exportErrorFragment,
  productErrorFragment,
  productErrorWithAttributesFragment,
  stockErrorFragment
} from "@saleor/fragments/errors";

import {
  exportFileFragment,
  fragmentVariant,
  productFragmentDetails,
  productInsFrament
} from "@saleor/fragments/products";
import makeMutation from "@saleor/hooks/makeMutation";
import gql from "graphql-tag";
import {
  ProductSkuExtraChargeCategory,
  ProductSkuExtraChargeCategoryVariables
} from "./types/ProductSkuExtraChargeCategory";

import {
  BulkCreatedProductByUploadfile,
  BulkCreatedProductByUploadfileVariables
} from "./types/BulkCreatedProductByUploadfile";
import {
  AssignRecommendProduct,
  AssignRecommendProductVariables
} from "./types/AssignRecommendProduct";
import {
  VariantBulkSetPrice,
  VariantBulkSetPriceVariables
} from "./types/VariantBulkSetPrice";
import {
  ClearImagesByProductId,
  ClearImagesByProductIdVariables
} from "./types/ClearImagesByProductId";
import {
  productBulkDelete,
  productBulkDeleteVariables
} from "./types/productBulkDelete";
import {
  productBulkPublish,
  productBulkPublishVariables
} from "./types/productBulkPublish";
import { ProductCreate, ProductCreateVariables } from "./types/ProductCreate";
import {
  ProductCreateProductins,
  ProductCreateProductinsVariables
} from "./types/ProductCreateProductins";
import { ProductDelete, ProductDeleteVariables } from "./types/ProductDelete";
import {
  ProductDeleteProductins,
  ProductDeleteProductinsVariables
} from "./types/ProductDeleteProductins";
import { ProductExport, ProductExportVariables } from "./types/ProductExport";
import {
  ProductImageCreate,
  ProductImageCreateVariables
} from "./types/ProductImageCreate";
import {
  ProductImageDelete,
  ProductImageDeleteVariables
} from "./types/ProductImageDelete";
import {
  ProductImageReorder,
  ProductImageReorderVariables
} from "./types/ProductImageReorder";
import {
  ProductImageUpdate,
  ProductImageUpdateVariables
} from "./types/ProductImageUpdate";
import {
  ProductNotTopInsReorder,
  ProductNotTopInsReorderVariables
} from "./types/ProductNotTopInsReorder";
import {
  ProductReorderInstagram,
  ProductReorderInstagramVariables
} from "./types/ProductReorderInstagram";
import {
  ProductS3DetailpageImageFetch,
  ProductS3DetailpageImageFetchVariables
} from "./types/ProductS3DetailpageImageFetch";
import {
  ProductS3ImageCreate,
  ProductS3ImageCreateVariables
} from "./types/ProductS3ImageCreate";
import {
  ProductS3ImageFetch,
  ProductS3ImageFetchVariables
} from "./types/ProductS3ImageFetch";
import {
  ProductSetAvailabilityForPurchase,
  ProductSetAvailabilityForPurchaseVariables
} from "./types/ProductSetAvailabilityForPurchase";
import {
  ProductSortProductins,
  ProductSortProductinsVariables
} from "./types/ProductSortProductins";
import {
  ProductUnsortProductins,
  ProductUnsortProductinsVariables
} from "./types/ProductUnsortProductins";
import { ProductUpdate, ProductUpdateVariables } from "./types/ProductUpdate";
import {
  ProductVariantBulkCreate,
  ProductVariantBulkCreateVariables
} from "./types/ProductVariantBulkCreate";
import {
  ProductVariantBulkDelete,
  ProductVariantBulkDeleteVariables
} from "./types/ProductVariantBulkDelete";
import {
  ProductVariantBulkPublishe,
  ProductVariantBulkPublisheVariables
} from "./types/ProductVariantBulkPublishe";
import {
  ProductVariantReorder,
  ProductVariantReorderVariables
} from "./types/ProductVariantReorder";
import {
  ProductVariantSetAvailabilityForPurchase,
  ProductVariantSetAvailabilityForPurchaseVariables
} from "./types/ProductVariantSetAvailabilityForPurchase";
import {
  ProductVariantSetDefault,
  ProductVariantSetDefaultVariables
} from "./types/ProductVariantSetDefault";
import {
  RecommendProductReorder,
  RecommendProductReorderVariables
} from "./types/RecommendProductReorder";
import {
  SimpleProductUpdate,
  SimpleProductUpdateVariables
} from "./types/SimpleProductUpdate";
import {
  UnassignRecommendProduct,
  UnassignRecommendProductVariables
} from "./types/UnassignRecommendProduct";
import { VariantCreate, VariantCreateVariables } from "./types/VariantCreate";
import { VariantDelete, VariantDeleteVariables } from "./types/VariantDelete";
import {
  VariantImageCreate,
  VariantImageCreateVariables
} from "./types/VariantImageCreate";
import {
  VariantImageDelete,
  VariantImageDeleteVariables
} from "./types/VariantImageDelete";
import {
  VariantImageReorder,
  VariantImageReorderVariables
} from "./types/VariantImageReorder";
import {
  VariantImageSetFirst,
  VariantImageSetFirstVariables
} from "./types/VariantImageSetFirst";
import {
  VariantImageUpdate,
  VariantImageUpdateVariables
} from "./types/VariantImageUpdate";
import {
  VariantS3ImageCreate,
  VariantS3ImageCreateVariables
} from "./types/VariantS3ImageCreate";
import {
  VariantS3ImageFetch,
  VariantS3ImageFetchVariables
} from "./types/VariantS3ImageFetch";
import {
  ProductVariantCopyCreate,
  ProductVariantCopyCreateVariables
} from "./types/productVariantCopyCreate";
import {
  ClearImagesByVariantId,
  ClearImagesByVariantIdVariables
} from "./types/clearImagesByVariantId";
import {
  ProductImageVisibleEditByUrl,
  ProductImageVisibleEditByUrlVariables
} from "./types/ProductImageVisibleEditByUrl";
import {
  VariantImageVisibleEditByUrl,
  VariantImageVisibleEditByUrlVariables
} from "./types/VariantImageVisibleEditByUrl";
// import {
//   VariantImageAssign,
//   VariantImageAssignVariables
// } from "./types/VariantImageAssign";
// import {
//   VariantImageUnassign,
//   VariantImageUnassignVariables
// } from "./types/VariantImageUnassign";
import { VariantUpdate, VariantUpdateVariables } from "./types/VariantUpdate";
import {
  ProductCopyToOtherSite,
  ProductCopyToOtherSiteVariables
} from "./types/ProductCopyToOtherSite";

export const productImageCreateMutation = gql`
  ${productErrorFragment}
  ${productFragmentDetails}
  mutation ProductImageCreate($product: ID!, $image: Upload!, $alt: String) {
    productImageCreate(input: { alt: $alt, image: $image, product: $product }) {
      errors: productErrors {
        ...ProductErrorFragment
      }
      product {
        ...Product
      }
    }
  }
`;
export const useProductImageCreateMutation = makeMutation<
  ProductImageCreate,
  ProductImageCreateVariables
>(productImageCreateMutation);

export const productS3ImageCreateMutation = gql`
  ${productErrorFragment}
  ${productFragmentDetails}
  mutation ProductS3ImageCreate($product: ID!, $image: String!, $alt: String) {
    productS3ImageCreate(
      input: { alt: $alt, image: $image, product: $product }
    ) {
      errors: productErrors {
        ...ProductErrorFragment
      }
      product {
        ...Product
      }
    }
  }
`;
export const useProductS3ImageCreateMutation = makeMutation<
  ProductS3ImageCreate,
  ProductS3ImageCreateVariables
>(productS3ImageCreateMutation);

export const productS3ImageFetchMutation = gql`
  ${productErrorFragment}
  ${productFragmentDetails}
  mutation ProductS3ImageFetch($productId: ID!) {
    productS3ImageFetch(productId: $productId) {
      errors: productErrors {
        ...ProductErrorFragment
      }
      product {
        ...Product
      }
    }
  }
`;
export const useProductS3ImageFetchMutation = makeMutation<
  ProductS3ImageFetch,
  ProductS3ImageFetchVariables
>(productS3ImageFetchMutation);

export const productS3DetailpageImageFetchMutation = gql`
  ${productErrorFragment}
  ${productFragmentDetails}
  mutation ProductS3DetailpageImageFetch($productId: ID!) {
    productS3DetailpageImageFetch(productId: $productId) {
      errors: productErrors {
        ...ProductErrorFragment
      }
      product {
        ...Product
      }
    }
  }
`;

export const useProductS3DetailpageImageFetchMutation = makeMutation<
  ProductS3DetailpageImageFetch,
  ProductS3DetailpageImageFetchVariables
>(productS3DetailpageImageFetchMutation);

export const productDeleteMutation = gql`
  ${productErrorFragment}
  mutation ProductDelete($id: ID!) {
    productDelete(id: $id) {
      errors: productErrors {
        ...ProductErrorFragment
      }
      product {
        id
      }
    }
  }
`;
export const useProductDeleteMutation = makeMutation<
  ProductDelete,
  ProductDeleteVariables
>(productDeleteMutation);

export const productImagesReorder = gql`
  ${productErrorFragment}
  mutation ProductImageReorder($productId: ID!, $imagesIds: [ID]!) {
    productImageReorder(productId: $productId, imagesIds: $imagesIds) {
      errors: productErrors {
        ...ProductErrorFragment
      }
      product {
        id
        images {
          id
          alt
          sortOrder
          url
        }
      }
    }
  }
`;
export const useProductImagesReorder = makeMutation<
  ProductImageReorder,
  ProductImageReorderVariables
>(productImagesReorder);

const productVariantSetDefault = gql`
  ${productErrorFragment}
  ${productFragmentDetails}
  mutation ProductVariantSetDefault($productId: ID!, $variantId: ID!) {
    productVariantSetDefault(productId: $productId, variantId: $variantId) {
      errors: productErrors {
        ...ProductErrorFragment
      }
      product {
        ...Product
      }
    }
  }
`;

export const useProductVariantSetDefaultMutation = makeMutation<
  ProductVariantSetDefault,
  ProductVariantSetDefaultVariables
>(productVariantSetDefault);

export const productUpdateMutation = gql`
  ${productErrorWithAttributesFragment}
  ${productFragmentDetails}
  mutation ProductUpdate($id: ID!, $input: ProductInput!) {
    productUpdate(id: $id, input: $input) {
      errors: productErrors {
        ...ProductErrorWithAttributesFragment
      }
      product {
        ...Product
      }
    }
  }
`;
export const useProductUpdateMutation = makeMutation<
  ProductUpdate,
  ProductUpdateVariables
>(productUpdateMutation);

export const simpleProductUpdateMutation = gql`
  ${bulkStockErrorFragment}
  ${productErrorWithAttributesFragment}
  ${productFragmentDetails}
  ${stockErrorFragment}
  ${fragmentVariant}
  mutation SimpleProductUpdate(
    $id: ID!
    $input: ProductInput!
    $productVariantId: ID!
    $productVariantInput: ProductVariantInput!
    $addStocks: [StockInput!]!
    $deleteStocks: [ID!]!
    $updateStocks: [StockInput!]!
  ) {
    productUpdate(id: $id, input: $input) {
      errors: productErrors {
        ...ProductErrorWithAttributesFragment
      }
      product {
        ...Product
      }
    }
    productVariantUpdate(id: $productVariantId, input: $productVariantInput) {
      errors: productErrors {
        ...ProductErrorWithAttributesFragment
      }
      productVariant {
        ...ProductVariant
      }
    }
    productVariantStocksCreate(
      stocks: $addStocks
      variantId: $productVariantId
    ) {
      errors: bulkStockErrors {
        ...BulkStockErrorFragment
      }
      productVariant {
        ...ProductVariant
      }
    }
    productVariantStocksDelete(
      warehouseIds: $deleteStocks
      variantId: $productVariantId
    ) {
      errors: stockErrors {
        ...StockErrorFragment
      }
      productVariant {
        ...ProductVariant
      }
    }
    productVariantStocksUpdate(
      stocks: $updateStocks
      variantId: $productVariantId
    ) {
      errors: bulkStockErrors {
        ...BulkStockErrorFragment
      }
      productVariant {
        ...ProductVariant
      }
    }
  }
`;
export const useSimpleProductUpdateMutation = makeMutation<
  SimpleProductUpdate,
  SimpleProductUpdateVariables
>(simpleProductUpdateMutation);

export const productCreateMutation = gql`
  ${productErrorWithAttributesFragment}
  ${productFragmentDetails}
  mutation ProductCreate($input: ProductCreateInput!) {
    productCreate(input: $input) {
      errors: productErrors {
        ...ProductErrorWithAttributesFragment
      }
      product {
        ...Product
      }
    }
  }
`;
export const useProductCreateMutation = makeMutation<
  ProductCreate,
  ProductCreateVariables
>(productCreateMutation);

export const variantDeleteMutation = gql`
  ${productErrorFragment}
  mutation VariantDelete($id: ID!) {
    productVariantDelete(id: $id) {
      errors: productErrors {
        ...ProductErrorFragment
      }
      productVariant {
        id
      }
    }
  }
`;
export const useVariantDeleteMutation = makeMutation<
  VariantDelete,
  VariantDeleteVariables
>(variantDeleteMutation);

export const variantUpdateMutation = gql`
  ${bulkStockErrorFragment}
  ${fragmentVariant}
  ${productErrorWithAttributesFragment}
  mutation VariantUpdate(
    $addStocks: [StockInput!]!
    $removeStocks: [ID!]!
    $id: ID!
    $attributes: [AttributeValueInput]
    $skuAttributes: [AttributeValueInput]
    $costPrice: PositiveDecimal
    $price: PositiveDecimal
    $sku: String
    $trackInventory: Boolean!
    $stocks: [StockInput!]!
    $weight: WeightScalar
    $extraCharge: JSONString
    $fromColor: String
    $toColor: String
    $isTwoColor: Boolean
    $colorThumbnail: String
    $shortDescription: String
    $fullDescription: String
    $framesImg: String
    $framesVideo: String
    $describe: String
    $USP: String
    $skuName: String
    $slug: String
    $seo: SeoInput
    $publicationDate: Date
    $isPublished: Boolean
    $cornermark: ID
    $extraChargeCategory: String
    $colorTagText: String
    $colorTagBackground: String
    $colorTagTextColor: String # $colorTagIcon: String
  ) {
    productVariantUpdate(
      id: $id
      input: {
        attributes: $attributes
        skuAttributes: $skuAttributes
        costPrice: $costPrice
        price: $price
        sku: $sku
        trackInventory: $trackInventory
        weight: $weight
        extraCharge: $extraCharge
        fromColor: $fromColor
        toColor: $toColor
        isTwoColor: $isTwoColor
        colorThumbnail: $colorThumbnail
        shortDescription: $shortDescription
        fullDescription: $fullDescription
        framesImg: $framesImg
        framesVideo: $framesVideo
        describe: $describe
        USP: $USP
        skuName: $skuName
        slug: $slug
        seo: $seo
        publicationDate: $publicationDate
        isPublished: $isPublished
        cornerMark: $cornermark
        extrachargeCategoryName: $extraChargeCategory
        colorTagText: $colorTagText
        colorTagBackground: $colorTagBackground
        colorTagTextColor: $colorTagTextColor
        # colorTagIcon: $colorTagIcon
      }
    ) {
      errors: productErrors {
        ...ProductErrorWithAttributesFragment
      }
      productVariant {
        ...ProductVariant
      }
    }
    productVariantStocksUpdate(stocks: $stocks, variantId: $id) {
      errors: bulkStockErrors {
        ...BulkStockErrorFragment
      }
      productVariant {
        ...ProductVariant
      }
    }
    productVariantStocksCreate(stocks: $addStocks, variantId: $id) {
      errors: bulkStockErrors {
        ...BulkStockErrorFragment
      }
      productVariant {
        id
        stocks {
          ...StockFragment
        }
      }
    }
    productVariantStocksDelete(warehouseIds: $removeStocks, variantId: $id) {
      errors: stockErrors {
        code
        field
      }
      productVariant {
        id
        stocks {
          ...StockFragment
        }
      }
    }
  }
`;
export const useVariantUpdateMutation = makeMutation<
  VariantUpdate,
  VariantUpdateVariables
>(variantUpdateMutation);

export const variantCreateMutation = gql`
  ${fragmentVariant}
  ${productErrorWithAttributesFragment}
  mutation VariantCreate($input: ProductVariantCreateInput!) {
    productVariantCreate(input: $input) {
      errors: productErrors {
        ...ProductErrorWithAttributesFragment
      }
      productVariant {
        ...ProductVariant
      }
    }
  }
`;
export const useVariantCreateMutation = makeMutation<
  VariantCreate,
  VariantCreateVariables
>(variantCreateMutation);

export const productImageDeleteMutation = gql`
  ${productErrorFragment}
  mutation ProductImageDelete($id: ID!) {
    productImageDelete(id: $id) {
      errors: productErrors {
        ...ProductErrorFragment
      }
      product {
        id
        images {
          id
        }
      }
    }
  }
`;
export const useProductImageDeleteMutation = makeMutation<
  ProductImageDelete,
  ProductImageDeleteVariables
>(productImageDeleteMutation);

export const productImageUpdateMutation = gql`
  ${productErrorFragment}
  ${productFragmentDetails}
  mutation ProductImageUpdate($id: ID!, $alt: String!) {
    productImageUpdate(id: $id, input: { alt: $alt }) {
      errors: productErrors {
        ...ProductErrorFragment
      }
      product {
        ...Product
      }
    }
  }
`;
export const useProductImageUpdateMutation = makeMutation<
  ProductImageUpdate,
  ProductImageUpdateVariables
>(productImageUpdateMutation);

// export const variantImageAssignMutation = gql`
//   ${fragmentVariant}
//   ${productErrorFragment}
//   mutation VariantImageAssign($variantId: ID!, $imageId: ID!) {
//     variantImageAssign(variantId: $variantId, imageId: $imageId) {
//       errors: productErrors {
//         ...ProductErrorFragment
//       }
//       productVariant {
//         ...ProductVariant
//       }
//     }
//   }
// `;
// export const useVariantImageAssignMutation = makeMutation<
//   VariantImageAssign,
//   VariantImageAssignVariables
// >(variantImageAssignMutation);

// export const variantImageUnassignMutation = gql`
//   ${fragmentVariant}
//   ${productErrorFragment}
//   mutation VariantImageUnassign($variantId: ID!, $imageId: ID!) {
//     variantImageUnassign(variantId: $variantId, imageId: $imageId) {
//       errors: productErrors {
//         ...ProductErrorFragment
//       }
//       productVariant {
//         ...ProductVariant
//       }
//     }
//   }
// `;
// export const useVariantImageUnassignMutation = makeMutation<
//   VariantImageUnassign,
//   VariantImageUnassignVariables
// >(variantImageUnassignMutation);

export const productBulkDeleteMutation = gql`
  ${productErrorFragment}
  mutation productBulkDelete($ids: [ID!]!) {
    productBulkDelete(ids: $ids) {
      errors: productErrors {
        ...ProductErrorFragment
      }
    }
  }
`;
export const useProductBulkDeleteMutation = makeMutation<
  productBulkDelete,
  productBulkDeleteVariables
>(productBulkDeleteMutation);

export const productBulkPublishMutation = gql`
  ${productErrorFragment}
  mutation productBulkPublish($ids: [ID!]!, $isPublished: Boolean!) {
    productBulkPublish(ids: $ids, isPublished: $isPublished) {
      errors: productErrors {
        ...ProductErrorFragment
      }
    }
  }
`;
export const useProductBulkPublishMutation = makeMutation<
  productBulkPublish,
  productBulkPublishVariables
>(productBulkPublishMutation);

export const ProductVariantBulkCreateMutation = gql`
  ${bulkProductErrorFragment}
  mutation ProductVariantBulkCreate(
    $id: ID!
    $inputs: [ProductVariantBulkCreateInput]!
  ) {
    productVariantBulkCreate(product: $id, variants: $inputs) {
      errors: bulkProductErrors {
        ...BulkProductErrorFragment
      }
    }
  }
`;
export const useProductVariantBulkCreateMutation = makeMutation<
  ProductVariantBulkCreate,
  ProductVariantBulkCreateVariables
>(ProductVariantBulkCreateMutation);

export const ProductVariantBulkDeleteMutation = gql`
  ${productErrorFragment}
  mutation ProductVariantBulkDelete($ids: [ID!]!) {
    productVariantBulkDelete(ids: $ids) {
      errors: productErrors {
        ...ProductErrorFragment
      }
    }
  }
`;
export const useProductVariantBulkDeleteMutation = makeMutation<
  ProductVariantBulkDelete,
  ProductVariantBulkDeleteVariables
>(ProductVariantBulkDeleteMutation);

export const productExportMutation = gql`
  ${exportFileFragment}
  ${exportErrorFragment}
  mutation ProductExport($input: ExportProductsInput!) {
    exportProducts(input: $input) {
      exportFile {
        ...ExportFileFragment
      }
      errors: exportErrors {
        ...ExportErrorFragment
      }
    }
  }
`;
export const useProductExport = makeMutation<
  ProductExport,
  ProductExportVariables
>(productExportMutation);

const productSetAvailabilityForPurchase = gql`
  ${productErrorFragment}
  mutation ProductSetAvailabilityForPurchase(
    $isAvailable: Boolean!
    $productId: ID!
    $startDate: DateTime
    $isPreOrder: Boolean!
    $preOrder: DateTime
  ) {
    productSetAvailabilityForPurchase(
      isAvailable: $isAvailable
      productId: $productId
      startDate: $startDate
      isPreOrder: $isPreOrder
      preOrder: $preOrder
    ) {
      product {
        id
        availableForPurchase
        isAvailableForPurchase
        isPreOrder
        preOrder
      }
      errors: productErrors {
        ...ProductErrorFragment
        message
      }
    }
  }
`;

export const useProductSetAvailabilityForPurchase = makeMutation<
  ProductSetAvailabilityForPurchase,
  ProductSetAvailabilityForPurchaseVariables
>(productSetAvailabilityForPurchase);

const productVariantSetAvailabilityForPurchase = gql`
  ${productErrorFragment}
  mutation ProductVariantSetAvailabilityForPurchase(
    $isAvailable: Boolean!
    $variantId: ID!
    $startDate: DateTime
    $isPreOrder: Boolean!
    $preOrder: DateTime
  ) {
    productVariantSetAvailabilityForPurchase(
      isAvailable: $isAvailable
      variantId: $variantId
      startDate: $startDate
      isPreOrder: $isPreOrder
      preOrder: $preOrder
    ) {
      variant {
        id
        availableForPurchase
        isAvailableForPurchase
        isPreOrder
        preOrder
      }
      errors: productErrors {
        ...ProductErrorFragment
        message
      }
    }
  }
`;

export const useProductVariantSetAvailabilityForPurchase = makeMutation<
  ProductVariantSetAvailabilityForPurchase,
  ProductVariantSetAvailabilityForPurchaseVariables
>(productVariantSetAvailabilityForPurchase);

const productVariantReorder = gql`
  ${productErrorFragment}
  ${productFragmentDetails}
  mutation ProductVariantReorder($move: ReorderInput!, $productId: ID!) {
    productVariantReorder(moves: [$move], productId: $productId) {
      errors: productErrors {
        ...ProductErrorFragment
      }
      product {
        ...Product
      }
    }
  }
`;
export const useProductVariantReorderMutation = makeMutation<
  ProductVariantReorder,
  ProductVariantReorderVariables
>(productVariantReorder);

export const variantImageCreateMutation = gql`
  ${productErrorFragment}
  ${fragmentVariant}
  mutation VariantImageCreate($variant: ID!, $image: Upload!, $alt: String) {
    variantImageCreate(input: { alt: $alt, image: $image, variant: $variant }) {
      errors: productErrors {
        ...ProductErrorFragment
      }
      variant {
        ...ProductVariant
      }
    }
  }
`;
export const useVariantImageCreateMutation = makeMutation<
  VariantImageCreate,
  VariantImageCreateVariables
>(variantImageCreateMutation);

export const variantS3ImageCreateMutation = gql`
  ${productErrorFragment}
  ${fragmentVariant}
  mutation VariantS3ImageCreate($variant: ID!, $image: String!, $alt: String) {
    variantS3ImageCreate(
      input: { alt: $alt, image: $image, variant: $variant }
    ) {
      errors: productErrors {
        ...ProductErrorFragment
      }
      variant {
        ...ProductVariant
      }
    }
  }
`;
export const useVariantS3ImageCreateMutation = makeMutation<
  VariantS3ImageCreate,
  VariantS3ImageCreateVariables
>(variantS3ImageCreateMutation);

export const variantS3ImageFetchMutation = gql`
  ${productErrorFragment}
  ${fragmentVariant}
  mutation VariantS3ImageFetch($variantId: ID!) {
    variantS3ImageFetch(variantId: $variantId) {
      errors: productErrors {
        ...ProductErrorFragment
      }
      variant {
        ...ProductVariant
      }
    }
  }
`;
export const useVariantS3ImageFetchMutation = makeMutation<
  VariantS3ImageFetch,
  VariantS3ImageFetchVariables
>(variantS3ImageFetchMutation);

export const variantImagesReorder = gql`
  ${productErrorFragment}
  mutation VariantImageReorder($variantId: ID!, $imagesIds: [ID]!) {
    variantImageReorder(variantId: $variantId, imagesIds: $imagesIds) {
      errors: productErrors {
        ...ProductErrorFragment
      }
      variant {
        id
        images {
          id
          alt
          sortOrder
          url
          isFirst
        }
      }
    }
  }
`;
export const useVariantImagesReorder = makeMutation<
  VariantImageReorder,
  VariantImageReorderVariables
>(variantImagesReorder);

export const variantImageSetFirst = gql`
  ${productErrorFragment}
  ${fragmentVariant}
  mutation VariantImageSetFirst($variantId: ID!, $imageId: ID!) {
    variantImageSetFirst(variantId: $variantId, imageId: $imageId) {
      errors: productErrors {
        ...ProductErrorFragment
      }
      variant {
        ...ProductVariant
      }
    }
  }
`;
export const useVariantImageSetFirstMutation = makeMutation<
  VariantImageSetFirst,
  VariantImageSetFirstVariables
>(variantImageSetFirst);

export const variantImageDeleteMutation = gql`
  ${productErrorFragment}
  mutation VariantImageDelete($id: ID!) {
    variantImageDelete(id: $id) {
      errors: productErrors {
        ...ProductErrorFragment
      }
      variant {
        id
        images {
          id
        }
      }
    }
  }
`;
export const useVariantImageDeleteMutation = makeMutation<
  VariantImageDelete,
  VariantImageDeleteVariables
>(variantImageDeleteMutation);

export const variantImageUpdateMutation = gql`
  ${productErrorFragment}
  ${fragmentVariant}
  mutation VariantImageUpdate($id: ID!, $alt: String!) {
    variantImageUpdate(id: $id, input: { alt: $alt }) {
      errors: productErrors {
        ...ProductErrorFragment
      }
      variant {
        ...ProductVariant
      }
    }
  }
`;
export const useVariantImageUpdateMutation = makeMutation<
  VariantImageUpdate,
  VariantImageUpdateVariables
>(variantImageUpdateMutation);

const productInsReorderMutation = gql`
  ${productFragmentDetails}
  ${productInsFrament}
  mutation ProductReorderInstagram($id: ID!, $move: ReorderInput!) {
    productReorderInstagram(productId: $id, moves: [$move]) {
      product {
        ...Product
        productIns(isOrder: "true") {
          ...ProductInsFrament
        }
        productSortIns {
          ...ProductInsFrament
        }
      }
      errors {
        message
      }
    }
  }
`;

export const useProductInsReorderMutation = makeMutation<
  ProductReorderInstagram,
  ProductReorderInstagramVariables
>(productInsReorderMutation);

const productNotTopInsReorderMutation = gql`
  ${productFragmentDetails}
  ${productInsFrament}
  mutation ProductNotTopInsReorder($id: ID!, $move: ReorderInput!) {
    productReorderNottopInstagram(productId: $id, moves: [$move]) {
      product {
        ...Product
        productIns(isOrder: "true") {
          ...ProductInsFrament
        }
        productSortIns {
          ...ProductInsFrament
        }
      }
      errors {
        message
      }
    }
  }
`;

export const useProductNotTopInsReorderMutation = makeMutation<
  ProductNotTopInsReorder,
  ProductNotTopInsReorderVariables
>(productNotTopInsReorderMutation);

const productDeleteProductinsMutation = gql`
  ${productFragmentDetails}
  ${productErrorFragment}
  mutation ProductDeleteProductins($id: ID!) {
    productDeleteProductins(id: $id) {
      product {
        ...Product
      }

      errors: productErrors {
        ...ProductErrorFragment
      }
    }
  }
`;

export const useProductDeleteProductinsMutation = makeMutation<
  ProductDeleteProductins,
  ProductDeleteProductinsVariables
>(productDeleteProductinsMutation);

const productUnsortProductInsMutation = gql`
  mutation ProductUnsortProductins($id: ID!) {
    productUnsortProductins(id: $id) {
      instagramProduct {
        id
        sortOrder
        imgUrl
        userName
        insId
        published
        product {
          id
        }
        instagram {
          id
        }
      }
      errors {
        message
        field
      }
    }
  }
`;

export const useproductUnsortProductInsMutation = makeMutation<
  ProductUnsortProductins,
  ProductUnsortProductinsVariables
>(productUnsortProductInsMutation);

const productCreateProductinsMutation = gql`
  ${productFragmentDetails}
  ${productErrorFragment}
  ${productInsFrament}
  mutation ProductCreateProductins($instagram: [ID]!, $product: ID!) {
    productCreateProductins(instagram: $instagram, product: $product) {
      product {
        ...Product
      }
      errors: productErrors {
        ...ProductErrorFragment
      }
    }
  }
`;

export const useProductCreateProductinsMutation = makeMutation<
  ProductCreateProductins,
  ProductCreateProductinsVariables
>(productCreateProductinsMutation);

const productSortProductins = gql`
  ${productFragmentDetails}
  ${productErrorFragment}
  ${productInsFrament}
  mutation ProductSortProductins($ids: [ID]!) {
    productSortProductins(ids: $ids) {
      product {
        ...Product
        productIns(isOrder: "true") {
          ...ProductInsFrament
        }
        productSortIns {
          ...ProductInsFrament
        }
      }
      errors: productErrors {
        ...ProductErrorFragment
      }
    }
  }
`;
export const useProductSortProductInsMutation = makeMutation<
  ProductSortProductins,
  ProductSortProductinsVariables
>(productSortProductins);

const assignRecommendProduct = gql`
  ${productErrorFragment}
  ${productFragmentDetails}
  ${categoryDetailsFragment}
  ${collectionDetailsFragment}
  mutation AssignRecommendProduct(
    $targetId: ID!
    $targetType: RecommendationTargetTypeEnum!
    $recommendType: RecommendationTypeEnum!
    $productIds: [ID]!
  ) {
    recommendProductAdd(
      targetId: $targetId
      targetType: $targetType
      recommendType: $recommendType
      productIds: $productIds
    ) {
      product {
        ...Product
      }
      category {
        ...CategoryDetailsFragment
      }
      collection {
        ...CollectionDetailsFragment
      }
      errors: productErrors {
        ...ProductErrorFragment
      }
    }
  }
`;

export const useAssignRecommendProductMutation = makeMutation<
  AssignRecommendProduct,
  AssignRecommendProductVariables
>(assignRecommendProduct);

const unassignRecommendProduct = gql`
  ${productErrorFragment}
  ${productFragmentDetails}
  ${categoryDetailsFragment}
  ${collectionDetailsFragment}
  mutation UnassignRecommendProduct(
    $targetId: ID!
    $targetType: RecommendationTargetTypeEnum!
    $recommendType: RecommendationTypeEnum!
    $productIds: [ID]!
  ) {
    recommendProductRemove(
      targetId: $targetId
      targetType: $targetType
      recommendType: $recommendType
      productIds: $productIds
    ) {
      product {
        ...Product
      }
      category {
        ...CategoryDetailsFragment
      }
      collection {
        ...CollectionDetailsFragment
      }
      errors: productErrors {
        ...ProductErrorFragment
      }
    }
  }
`;

export const useUnassignRecommendProductMutation = makeMutation<
  UnassignRecommendProduct,
  UnassignRecommendProductVariables
>(unassignRecommendProduct);

const recommendProductReorder = gql`
  ${productErrorFragment}
  ${productFragmentDetails}
  ${categoryDetailsFragment}
  ${collectionDetailsFragment}
  mutation RecommendProductReorder(
    $move: MoveProductInput!
    $targetId: ID!
    $targetType: RecommendationTargetTypeEnum!
    $recommendType: RecommendationTypeEnum!
  ) {
    recommendProductReorder(
      moves: [$move]
      targetId: $targetId
      targetType: $targetType
      recommendType: $recommendType
    ) {
      errors: productErrors {
        ...ProductErrorFragment
      }
      product {
        ...Product
      }
      category {
        ...CategoryDetailsFragment
      }
      collection {
        ...CollectionDetailsFragment
      }
    }
  }
`;

export const useRecommendProductReorderMutation = makeMutation<
  RecommendProductReorder,
  RecommendProductReorderVariables
>(recommendProductReorder);

const clearImagesByProductId = gql`
  ${productErrorFragment}
  ${productFragmentDetails}
  mutation ClearImagesByProductId($productId: ID!) {
    clearImagesByProductId(productId: $productId) {
      errors: productErrors {
        ...ProductErrorFragment
      }
      product {
        ...Product
      }
    }
  }
`;

export const useClearImagesByProductIdMutation = makeMutation<
  ClearImagesByProductId,
  ClearImagesByProductIdVariables
>(clearImagesByProductId);

const productVariantBulkPublishe = gql`
  mutation ProductVariantBulkPublishe($ids: [ID!]!, $isPublished: Boolean!) {
    productVariantBulkPublishe(ids: $ids, isPublished: $isPublished) {
      productErrors {
        code
        field
      }
    }
  }
`;
export const useProductVariantBulkPublisheMutation = makeMutation<
  ProductVariantBulkPublishe,
  ProductVariantBulkPublisheVariables
>(productVariantBulkPublishe);

const productVariantCopyCreate = gql`
  ${fragmentVariant}
  ${productErrorFragment}
  mutation ProductVariantCopyCreate($id: ID!) {
    productVariantCopyCreate(id: $id) {
      errors: productErrors {
        ...ProductErrorFragment
      }
      productVariant {
        ...ProductVariant
      }
    }
  }
`;

export const useProductVariantCopyCreateMutation = makeMutation<
  ProductVariantCopyCreate,
  ProductVariantCopyCreateVariables
>(productVariantCopyCreate);

const clearImagesByVariantId = gql`
  ${fragmentVariant}
  mutation ClearImagesByVariantId($variantId: ID!) {
    clearImagesByVariantId(variantId: $variantId) {
      variant {
        ...ProductVariant
      }
      errors {
        field
        message
      }
    }
  }
`;
export const useClearImagesByVariantIdMutation = makeMutation<
  ClearImagesByVariantId,
  ClearImagesByVariantIdVariables
>(clearImagesByVariantId);

const productSkuExtraChargeCategory = gql`
  mutation ProductSkuExtraChargeCategory($id: ID!, $isActive: Boolean!) {
    productSkuExtraChargeCategory(id: $id, isActive: $isActive) {
      skuExtraChargeCategory {
        id
        name
        isActive
      }
      errors {
        field
        message
      }
    }
  }
`;
export const useProductSkuExtraChargeCategoryMutation = makeMutation<
  ProductSkuExtraChargeCategory,
  ProductSkuExtraChargeCategoryVariables
>(productSkuExtraChargeCategory);

const productImageVisibleEditByUrl = gql`
  mutation ProductImageVisibleEditByUrl($id: ID!) {
    productImageVisibleEditByUrl(id: $id) {
      productErrors {
        field
        message
      }
    }
  }
`;

export const useProductImageVisibleEditByUrlMutation = makeMutation<
  ProductImageVisibleEditByUrl,
  ProductImageVisibleEditByUrlVariables
>(productImageVisibleEditByUrl);

const variantImageVisibleEditByUrl = gql`
  mutation VariantImageVisibleEditByUrl($id: ID!) {
    variantImageVisibleEditByUrl(id: $id) {
      errors {
        field
        message
      }
    }
  }
`;

export const useVariantImageVisibleEditByUrlMutation = makeMutation<
  VariantImageVisibleEditByUrl,
  VariantImageVisibleEditByUrlVariables
>(variantImageVisibleEditByUrl);

const productCopyToOtherSite = gql`
  ${productErrorWithAttributesFragment}
  ${productFragmentDetails}
  mutation ProductCopyToOtherSite($id: ID!) {
    productCopyToOtherSite(id: $id) {
      errors: productErrors {
        ...ProductErrorWithAttributesFragment
      }
      product {
        ...Product
      }
    }
  }
`;
export const useProductCopyToOtherSiteMutation = makeMutation<
  ProductCopyToOtherSite,
  ProductCopyToOtherSiteVariables
>(productCopyToOtherSite);

const variantBulkSetPrice = gql`
  ${productFragmentDetails}
  mutation VariantBulkSetPrice($ids: [ID]!, $price: PositiveDecimal!) {
    variantBulkSetPrice(ids: $ids, price: $price) {
      product {
        ...Product
      }
      errors {
        field
        message
      }
    }
  }
`;
export const useVariantBulkSetPriceMutation = makeMutation<
  VariantBulkSetPrice,
  VariantBulkSetPriceVariables
>(variantBulkSetPrice);

const bulkCreatedProductByUploadfile = gql`
  mutation BulkCreatedProductByUploadfile($excelFile: Upload) {
    bulkCreatedProductByUploadfile(excelFile: $excelFile) {
      productErrors {
        field
        message
      }
    }
  }
`;
export const useBulkCreatedProductByUploadfile = makeMutation<
  BulkCreatedProductByUploadfile,
  BulkCreatedProductByUploadfileVariables
>(bulkCreatedProductByUploadfile);
